import React, { Dispatch, useContext, useReducer } from "react";
import { IUserData } from "../../../../interfaces/user/IUserData";

type BlogNavigationContextProps = {
  state: BlogNavigationState;
  dispatch: Dispatch<BlogNavigationState>;
};

type BlogNavigationState = {
  tab?: number;
  followingCoaches?: { count: number; rows: IUserData[] };
  coaches?: { count: number; rows: IUserData[] };
  filterFor?: FilterFor;
};

const BlogNavigationContext = React.createContext<
  BlogNavigationContextProps | undefined
>(undefined);

export enum BlogNavigationTabs {
  EXPLORE,
  FOLLOWING,
}

export enum FilterFor {
  EXPLORE = "blogs",
  FOLLOWING = "followingCoachesBlogs",
}

const initialState = {
  tab: BlogNavigationTabs.EXPLORE,
  followingCoaches: { count: 0, rows: [] },
  coaches: { count: 0, rows: [] },
  filterFor: FilterFor.EXPLORE,
};

const blogNavigationReducer = (
  state: BlogNavigationState,
  newState: BlogNavigationState,
): BlogNavigationState => {
  return {
    tab: newState.tab ?? state.tab,
    followingCoaches: newState.followingCoaches ?? state.followingCoaches,
    coaches: newState.coaches ?? state.coaches,
    filterFor: newState.filterFor ?? state.filterFor,
  };
};

export const BlogNavigationProvider = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const [state, dispatch] = useReducer(blogNavigationReducer, initialState);

  return (
    <BlogNavigationContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </BlogNavigationContext.Provider>
  );
};

export const useBlogNavigationContext = () => {
  const context = useContext(BlogNavigationContext);

  if (!context) {
    throw new Error(
      "useBlogNavigationContext must be used within a FirebaseProvider",
    );
  }

  return context;
};
